var SpotHelper = {

	screenToSphereCoords: function(xx, yy, rawcoords) {
		var m4t = new THREE.Matrix4();
    	var m4r = new THREE.Matrix4();
    	var playernode = $("body");

        var raycaster = new THREE.Raycaster();
        var mouse = new THREE.Vector2();

        if (rawcoords != undefined) {
        	mouse.x = xx;
        	mouse.y = yy;
        } else {
        	mouse.x = ( xx / playernode.width()) * 2 - 1;
        	mouse.y = - ( yy / playernode.height()) * 2 + 1;
    	}

        raycaster.setFromCamera( mouse, player.currentView.renderer.camera );

        var objects = [];
        var intersects = raycaster.intersectObject( player.currentView.renderer.preview, false);

        var out = new THREE.Vector4();
        out.fromArray([intersects[0].point.x, intersects[0].point.y, intersects[0].point.z, 0]);
		
        m4r.makeRotationY((360 - (player.currentView.renderer.jaw * 180 / Math.PI)) * Math.PI / 180);
        m4t.makeRotationX(player.currentView.renderer.pitch * -1);
        m4r.multiply(m4t);
        
        out = out.applyMatrix4(m4r);

        var inn = new THREE.Vector4();
        inn.fromArray([intersects[0].point.x, intersects[0].point.y, intersects[0].point.z, 0]);
		
        m4r.makeRotationY(-player.currentView.renderer.preview.rotation.y);
        m4t.makeRotationX(-player.currentView.renderer.preview.rotation.x);
        m4r.multiply(m4t);

        inn = inn.applyMatrix4(m4r);

        return {
        	"out": new Vector3D(out.x, out.y, out.z),
			"in": new Vector3D(inn.x, inn.y, inn.z)
		};
	}

}

function DummySpot(no) {	
	this.node = $("<div id='dummy" + no + "' style='position: absolute;'><div style='transform:translate(-50%, -100%);'><img src='/storage/collectibles/2.png' width='300'></div></div>");
	//	this.node = $("<div id='dummy" + no + "' style='position: absolute;'><div style='translate(-50%, -50%);'><img src='/storage/collectibles/2.png' width='400'></div></div>");

	$("#hotspots").append(this.node);
	this.no = no;
	this.node3D = new css3DNode("#dummy" + this.no);
}

DummySpot.prototype = {
	setVisibility: function(b) {
		if (b) this.node.css("visibility", "visible");
		else this.node.css("visibility", "hidden");
	},

	updateScreenCoords: function(x, y) {

		var sx = Math.abs((x - (HotSpotManager.playerWidth * 0.5)) / (HotSpotManager.playerWidth * 0.5));

		this.node3D.resetTransform();
		this.node3D.translate(x, y, 0);
//		this.node3D.scale(1, 1, 1);
//		this.node3D.scale(sx + 1, sx + 1, sx + 1);
		this.node3D.applyTransforms();
	},

	appendUI: function(node) {
		this.node.append(node);
	}
}

function PlaneSpot3D(no, img) {	
	//sphereWebGLStatic.renderer
	this.pos = {};
	this.scale = 1;
	this.loaded = false;
	this.node = $("<div id='dummy" + no + "' style='position: absolute;'></div>");
	$("#hotspots").append(this.node);
	this.no = no;
	this.node3D = new css3DNode("#dummy" + this.no);
	this.layerMul = 1;
	this.ry = 0;

	var ltex = new THREE.TextureLoader().load( "https://" + window.PROJECT.host + img, function(lt) {

		const plateMaterial = new THREE.MeshBasicMaterial( {color: 0xffffff, side: THREE.DoubleSide, map:ltex, transparent: true} );
		
		const plateGeom = new THREE.PlaneGeometry( 10, 20, 5, 5 );

		this.spotPlate = new THREE.Mesh(plateGeom, plateMaterial);
		this.spotPlate.layers.set(sphereWebGLStatic.cycle);
		sphereWebGLStatic.self.preview.add( this.spotPlate );
		this.loaded = true;
	}.bind(this));
}

PlaneSpot3D.prototype = {
	setVisibility: function(b) {
	},

	setPosition: function(out, inn) {

		this.pos = new Vector3D(inn.x * 0.9, inn.y * 0.9, inn.z * 0.9);

	},

	setLayer: function(n) {
	},

	updateScreenCoords: function(x, y) {
		if (this.spotPlate != undefined) {

			this.spotPlate.position.set(this.pos.x * this.layerMul, this.pos.y * this.layerMul, this.pos.z * this.layerMul);
			this.spotPlate.quaternion.copy(sphereWebGLStatic.self.camera.quaternion);
			this.spotPlate.lookAt(new Vector3D(0, 0, 0));
		}

		if (this.spotPlateOutline != undefined) {

			this.spotPlateOutline.position.set(this.pos.x * this.layerMul, this.pos.y * this.layerMul, this.pos.z * this.layerMul);
			this.spotPlateOutline.quaternion.copy(sphereWebGLStatic.self.camera.quaternion);
			this.spotPlateOutline.lookAt(new Vector3D(0, 0, 0));
		}

		var sx = Math.abs((x - (HotSpotManager.playerWidth * 0.5)) / (HotSpotManager.playerWidth * 0.5));

		this.node3D.resetTransform();
		this.node3D.translate(x, y, 0);
//		this.node3D.scale(1, 1, 1);
//		this.node3D.scale(sx + 1, sx + 1, sx + 1);
		this.node3D.applyTransforms();

		if (HotSpotManager.cursor3D.raycaster == undefined) return;

		var ret = HotSpotManager.cursor3D.raycaster.intersectObject(this.spotPlate, false);

		if (this.clicked) {
			if (this.scale > 0.1) this.scale *= 0.9;

		} else if  (this.sphereSpot.data.record.settings != undefined && this.sphereSpot.data.record.settings.scale != undefined)  this.scale = parseFloat(this.sphereSpot.data.record.settings.scale) * 0.01;
		
		this.spotPlate.scale.set(this.scale, this.scale, this.scale); 
		if (this.spotPlateOutline != undefined) this.spotPlateOutline.scale.set(this.scale, this.scale, this.scale); 

		if (ret.length > 0) {
			if (panoramaViewStatic.root.panning) this.clicked = true;
//			if (panoramaViewStatic.root.panning) this.spotPlate.scale.set(0.8, 0.8, 0.8); 
//			else this.spotPlate.scale.set(scale, scale, scale); 

			this.blink(true);
		} else {
			this.blink(false);
//			this.spotPlate.scale.set(scale, scale, scale);
		}
	},

	appendUI: function(node) {
		this.node.append(node);
	},

	blink: function(b) {
		if (b) this.spotPlate.material.opacity = this.curOpacity * 0.85;
		else this.spotPlate.material.opacity = this.curOpacity;
	}
}

function Collectible3D(c, no) {	
	//sphereWebGLStatic.renderer
	var no = "collect-" + c.id;
	var img = "/storage/collectibles/" + c.image;

	if (c.settings == undefined) c.settings = {};

	this.sounds = {
		"collect": new AudioEffect("assets/audio/games/collect.mp3"),
		"backpack": new AudioEffect("assets/audio/games/backpack.mp3"),
	};
	this.sounds.collect.setVolume(0.1);

	this.layerMul = 1;

	this.loaded = 0;

	this.c = c;
	this.pos = {};
	this.scale = 1;
	this.node = $("<div id='dummy" + no + "' style='position: absolute;'></div>");
	$("#hotspots").append(this.node);
	this.no = no;
	this.node3D = new css3DNode("#dummy" + this.no);
	this.hovering = false;

	this.ry = 0;

	this.firstShow = true;

	try {
		this.scale = parseFloat(this.sphereSpot.data.record.settings.scale) * 0.01;
	} catch(e) {}

	this.prepareStates();

	if (this.c.settings.layer != undefined) this.setLayer(this.c.settings.layer);

	this.image = img;

//	var ltex = new THREE.TextureLoader().load( "https://" + window.PROJECT.host + img, function(lt) {
	CachedMaterialLoader.load("collectibles", "https://" + window.PROJECT.host + img, function(cache) {

		var lt = cache.texture;
		var res = {};
		if (lt == null) lt = cache.default.map;

		var iratio = lt.image.width / lt.image.height;

		if (cache.new) {
			var plateMaterial = new THREE.MeshBasicMaterial( {color: 0xffffff, side: THREE.FrontSide, map:lt, transparent: true, needsUpdate: true, depthWrite: false} );
			res.default = plateMaterial;
		} else {
			var plateMaterial = cache.default;
		}

		this.destOpacity = 1;
		this.stepOpacity = 0.05;

		if (this.c.settings.alpha != undefined) {
			this.destOpacity = parseFloat(this.c.settings.alpha) * 0.01;
		}

		var ratio = lt.image.width / lt.image.height;
		const plateGeom = new THREE.PlaneGeometry( 10, 10 / ratio, 5, 5 );
	
		this.spotPlate = new THREE.Mesh(plateGeom, plateMaterial);
		this.spotPlate.layers.set(sphereWebGLStatic.cycle);
		this.spotPlate.scale.set(this.scale, this.scale, this.scale);
		this.spotPlate.visible = false;

		this.spotPlate.up = new THREE.Vector3(0,1,0);
		this.spotPlate.material.opacity = 0;

		if (this.c.type == 'deliver') {
			if (cache.new) {
				const canvas = document.createElement( 'canvas' );

				var cs = parseFloat(this.c.settings.scale) * 0.03;

				if (iratio >= 1) {
					canvas.width = (256 * iratio * cs);
					canvas.height = (256 * cs);

					if (canvas.height < 32) {
						canvas.width = 32 * iratio;
						canvas.height = 32;
					}
				} else {
					canvas.width = ((256) * cs);
					canvas.height = ((256 / iratio) * cs);

					if (canvas.width < 32) {
						canvas.width = 32;
						canvas.height = 32 / iratio;
					}
				}
					
				const context = canvas.getContext( '2d' );
				context.drawImage( lt.image, 0, 0, canvas.width, canvas.height );
					
				const idata = context.getImageData(0, 0, canvas.width, canvas.height);
				
				var ndata = this.addGlow(idata.data, canvas.width, canvas.height);
				
				const ntex = new THREE.DataTexture( ndata, canvas.width, canvas.height );
				ntex.magFilter = THREE.LinearFilter;
				ntex.minFilter = THREE.LinearFilter;

				ntex.needsUpdate = true;

				var plateMaterialOutline = new THREE.MeshBasicMaterial( {color: 0xffffff, side: THREE.FrontSide, map:ntex, transparent: true, needsUpdate: true, depthWrite: false} );
				plateMaterialOutline.blending = THREE.AdditiveBlending;
				plateMaterialOutline.opacity = 0.3;

				res.outline = plateMaterialOutline;
			} else {
				var plateMaterialOutline = cache.outline;
			}

			const plateGeomOutline = new THREE.PlaneGeometry( 10, 10 / ratio, 5, 5 );
			
			this.spotPlateOutline = new THREE.Mesh(plateGeomOutline, plateMaterialOutline);
			this.spotPlateOutline.layers.set(sphereWebGLStatic.cycle);
			this.spotPlateOutline.scale.set(this.scale, this.scale, this.scale);

			this.spotPlateOutline.visible = false;

			if (Equipment.delivered[this.c.settings.accept] == undefined) {
				 this.destOpacity = 0.3;
			} else {
				this.delivered = true;
			}
			
			sphereWebGLStatic.self.preview.add( this.spotPlateOutline );			
		}
		this.loaded = 1;

		if (cache.new) {
			setTimeout(function() {
				sphereWebGLStatic.self.preview.add( this.spotPlate );
				this.loaded = 2;
			}.bind(this), 50);
		} else {
			sphereWebGLStatic.self.preview.add( this.spotPlate );
			this.loaded = 2;
		}

		//this.curOpacity = cache.new ? 0 : this.destOpacity;
		//if (!cache.new) this.spotPlate.material.opacity = this.destOpacity;
		
		this.curOpacity = 0;
		this.spotPlate.material.opacity = 0;
		this.stepOpacity = cache.new ? 0.01 : 0.05;

		return res;

	}.bind(this));

	$("body").on("mouseup", this.mouseUp.bind(this));
}

Collectible3D.prototype = {

	filterMtx: function(data, cx, cy, sx, sy, mtx, cvx, cvy, div, str) {
		var hx = (sx - 1) * 0.5;
		var hy = (sy - 1) * 0.5;

		var mx = 0;
		var my = 0;

		var wsum = {"r": 0, "g": 0, "b": 0, "a": 0};

		//return (data[(cx + cy * cvx) * 4] + data[(cx + cy * cvx) * 4 + 1] + data[(cx + cy * cvx) * 4 + 2]) / 3;

		var tmp = {};


		for(var y = cy - hy; y <= cy + hy; y ++) {
			mx = 0;

			for(var x = cx - hx; x <= cx + hx; x ++) {
				var weight = mtx[mx + my * sx] * str;
//				var value = (data[(x + y * cvx) * 4] + data[(x + y * cvx) * 4 + 1] + data[(x + y * cvx) * 4 + 2]) / 3;
				/*
				var value = data[(x + y * cvx) * 4];
				if (isNaN(value)) value = 0;
				wsum.r += value * weight;

				value = data[(x + y * cvx) * 4 + 1];
				if (isNaN(value)) value = 0;

				wsum.g += value * weight;

				value = data[(x + y * cvx) * 4 + 2];
				if (isNaN(value)) value = 0;

				wsum.b += value * weight;
				*/
				value = data[(x + y * cvx) * 4 + 3];
				if (isNaN(value)) value = 0;

				wsum.a += value * weight;

				mx ++;
			}

			my ++;
		}

		//if (wsum > 150 || wsum < -150) return 255;
		/*
		wsum.r = wsum.r / div;
		wsum.g = wsum.g / div;
		wsum.b = wsum.b / div;
		*/
		wsum.a = wsum.a / div;

		return wsum;

	},

	addGlow: function(raw, w, h) {
		var data = new Uint8Array( 4 * w * h);

		for(var y = 0; y < h; y++) {
			for(var x = 0; x < w; x++) {
				var px = {"r": raw[(x + y * w) * 4], "g": raw[(x + y * w) * 4 + 1], "b": raw[(x + y * w) * 4 + 2], "a": raw[(x + y * w) * 4 + 3]};

//				var cvmtxh = [-1, 0, 1, -2, 0, 2, -1, 0, 1];
//				var cvmtxv = [-1, -2, -1, 0, 0, 0, 1, 2, 1];

				var cvmtxh = [-1, -1, -1, -1, 8, -1, -1, -1, -1];

//				var result = this.filterMtx(raw, x, y, 3, 3, cvmtxh, w, h, 1, 1)
//				if (result.a > 100 || result.a < -100) result.a = 255; else result.a = 0;

//				var result2 = this.filterMtx(raw, x, y, 3, 3, cvmtxv, w, h, 9, 1);
//				if (result2> 100 || result2 < -100) result2 = 255; else result2 = 0;
				
				data[(x + (h - y) * w) * 4] = 255;
				data[(x + (h - y) * w) * 4 + 1] = 255;
				data[(x + (h - y) * w) * 4 + 2] = 255;
				var cs = 0;//result.a;// + result2;
				cs = raw[(x + y * w) * 4 + 3];
				if (cs > 120) cs = 255; else cs = 0;
				//if (cs > 255) cs = 255;
				data[(x + (h - y) * w) * 4 + 3] = cs;
				/*
				data[(x + (h - y) * w) * 4] = px.r;
				data[(x + (h - y) * w) * 4 + 1] = px.g;
				data[(x + (h - y) * w) * 4 + 2] = px.b;
				data[(x + (h - y) * w) * 4 + 3] = px.a;// + result2;
				*/
			}
		}

		var front = new Uint8Array( 4 * w * h);
		var tmp = null;

		for(var blur = 1; blur < 4; blur ++) {
			for(var y = 0; y < h; y++) {
				for(var x = 0; x < w; x++) {
					var cvmtx = [1,  4,  7,  4, 1, 
								 4, 16, 26, 16, 4,
								 7, 26, 41, 26, 7,
								 4, 16, 26, 16, 4,
								 1,  4,  7,  4, 1
								 ];

					var cvmtx = [1, 1, 1, 1, 1, 1, 1, 1, 1];

					/*var cvmtx = [1, 1, 1, 1, 1, 
								 1, 1, 1, 1, 1, 
								 1, 1, 1, 1, 1, 
								 1, 1, 1, 1, 1, 
								 1, 1, 1, 1, 1];
					*/

					//var result = this.filterMtx(data, x, y, 5, 5, cvmtx, w, h, 273, 1);
					var result = this.filterMtx(data, x, y, 3, 3, cvmtx, w, h, 9, 1);

					/*
					front[(x + y * w) * 4] = result.r;
					front[(x + y * w) * 4 + 1] = result.g;
					front[(x + y * w) * 4 + 2] = result.b;
					front[(x + y * w) * 4 + 3] = result.a;
					*/
					
					//255,228,181
					front[(x + y * w) * 4] = 255;
					front[(x + y * w) * 4 + 1] = 255;
					front[(x + y * w) * 4 + 2] = 255;
					var ra = (data[(x + y * w) * 4 + 3] * 0.5) + result.a;
					if (ra > 255) ra = 255;
					front[(x + y * w) * 4 + 3] = ra; // - uncomment for additive bluring - good for outlines
				}
			}

			tmp = front;
			front = data;
			data = tmp;
		}

		return data;
	},

	prepareStates: function() {
		this.sm = new StateMachine(this, {});
		
		this.sm.addState("idle", {"handle": function(sm, p) {
			if (this.clicked && this.c.type == "collect") {
				this.sounds.collect.play();

				var img = "/storage/collectibles/" + this.c.icon;
				p.collect = $("<div style='transform: translate(-50%, -50%);position:absolute;'><img src='" + img + "' style='width: 100px;'></div>");
				p.collect.css("opacity", "0");
				$("#hotspots").append(p.collect);
				p.x = this.x2d;
				p.y = this.y2d;
				p.cx = p.x;
				p.cy = p.y;
				p.dy = 1;
				p.dx = 1;
				p.alpha = 0;
				p.collect.css("left", this.x2d);
				p.collect.css("top", this.y2d);

				this.erp.setStart({"alpha": 0});
				this.erp.setEnd({"alpha": 1});
				this.erp.reset();

				return 'collect';
			} else if  (this.sphereSpot.data.record.settings != undefined && this.sphereSpot.data.record.settings.scale != undefined)  this.scale = parseFloat(this.sphereSpot.data.record.settings.scale) * 0.01;		
		}});
		
		this.erp = new Interpolate();

		this.sm.addState("collecting", {"handle": function(sm, p) {
			this.erp.next(0.2);
			var alpha = this.erp.cycleProperty("alpha", "easeInCubic");
			p.collect.css("transform", "translate(-50%, -50%) scale(" + alpha + ", " + alpha + ")");
			p.collect.css("opacity", alpha);

			if (this.erp.pos >= 1) {

				this.spotPlate.visible = false;
				if (this.spotPlateOutline != undefined) this.spotPlateOutline.visible = false;
				this.clicked = false;

				Equipment.collect(this.c);
				var eq = Equipment.dropPosition();
				eq.alpha = 0;

				this.erp.setStart({"x": p.x, "y": p.y, "alpha": 1});
				this.erp.setEnd({"x": eq.x, "y": eq.y, "alpha": 0});
				this.erp.reset();

				return 'done';
			}

			return null;
		}});

		this.sm.addState("flying", {"handle": function(sm, p) {
			var eq = Equipment.dropPosition();

			//p.cx += (eq.x - p.x) * 0.01;
			//p.cy += (eq.y - p.y) * 0.01;
			this.erp.next(0.8);
			p.cy = this.erp.cycleProperty("y", "easeInCubic");
			p.cx = this.erp.cycleProperty("x", "linear");
			p.alpha = this.erp.cycleProperty("alpha", "easeInCubic");

			p.collect.css("left", p.cx);
			p.collect.css("top", p.cy);
			p.collect.css("opacity", p.alpha);

			if (this.rot == undefined) this.rot = 0;
			else this.rot += 5;

			p.collect.css("transform", "translate(-50%, -50%) rotate(" + this.rot + "deg)");

			if (this.erp.pos <= 1)
				return null;
			else {
				return "done";
			}
		}});

		this.sm.addState("collected", {"handle": function(sm, p) {
			this.sounds.backpack.play();
			Equipment.vibrate();
			return true;
		}});
		
		this.sm.transit('idle', 'collect', 'collecting');
		this.sm.transit('collecting', 'done', 'flying');
		this.sm.transit('flying', 'done', 'collected');
	},

	setVisibility: function(b) {
	},

	setPosition: function(out, inn) {

		this.pos = new Vector3D(inn.x * 0.9, inn.y * 0.9, inn.z * 0.9);

	},

	setLayer: function(n) {
		switch(n) {
			case "1": this.layerMul = 1; break;
			case "2": this.layerMul = 0.95; break;
			case "3": this.layerMul = 0.9; break;
			case "4": this.layerMul = 0.85; break;
			case "5": this.layerMul = 0.8; break;
			case "6": this.layerMul = 0.75; break;
			case "7": this.layerMul = 0.7; break;
			case "8": this.layerMul = 0.65; break;
			case "9": this.layerMul = 0.6; break;
			case "10": this.layerMul = 0.55; break;
/*			case "2": this.layerMul = 0.98; break;
			case "3": this.layerMul = 0.96; break;
			case "4": this.layerMul = 0.94; break;
			case "5": this.layerMul = 0.92; break;
			case "6": this.layerMul = 0.90; break;
			case "7": this.layerMul = 0.88; break;
			case "8": this.layerMul = 0.86; break;
			case "9": this.layerMul = 0.84; break;
			case "10": this.layerMul = 0.82; break;*/
		}
	},

	process: function() {
		this.sm.process();
	},

	updateScreenCoords: function(x, y) {
		if (this.spotPlate != undefined) {

			if (this.curOpacity < this.destOpacity && this.loaded > 1) {
				this.curOpacity += this.destOpacity * this.stepOpacity;
				if (this.curOpacity > 1) this.curOpacity = 1;
				this.spotPlate.material.opacity = this.curOpacity;
			}
			
			this.spotPlate.position.set(this.pos.x * this.layerMul, this.pos.y * this.layerMul, this.pos.z * this.layerMul);
//			this.spotPlate.quaternion.copy(sphereWebGLStatic.self.camera.quaternion);
//			this.spotPlate.lookAt(0, 0, 0);
//			this.spotPlate.up = new THREE.Vector3(0,1,0);

			this.spotPlate.up = sphereWebGLStatic.self.cup;

//			sphereWebGLStatic.self.preview.up = new THREE.Vector3(0,1,0);

			this.spotPlate.lookAt(new THREE.Vector3(0, 0, 0));
			
			// outline
			if (this.spotPlateOutline != undefined) {
				this.spotPlateOutline.position.set(this.pos.x * this.layerMul, this.pos.y * this.layerMul, this.pos.z * this.layerMul);
				this.spotPlateOutline.quaternion.copy(sphereWebGLStatic.self.camera.quaternion);
				this.spotPlateOutline.lookAt(new THREE.Vector3(0, 0, 0));
			}

			if (this.firstShow) {
				this.spotPlate.scale.set(this.scale * this.layerMul, this.scale * this.layerMul, this.scale * this.layerMul);
				if (this.spotPlateOutline != undefined) {
					this.spotPlateOutline.scale.set(this.scale * this.layerMul, this.scale * this.layerMul, this.scale * this.layerMul);
					this.spotPlateOutline.visible = true;
				}

				this.spotPlate.visible = true;
				this.firstShow = false;
			}
		}

		var sx = Math.abs((x - (HotSpotManager.playerWidth * 0.5)) / (HotSpotManager.playerWidth * 0.5));

		this.x2d = x;
		this.y2d = y;

		this.node3D.resetTransform();
		this.node3D.translate(x, y, 0);
//		this.node3D.scale(1, 1, 1);
//		this.node3D.scale(sx + 1, sx + 1, sx + 1);
		this.node3D.applyTransforms();

		if (HotSpotManager.cursor3D.raycaster == undefined) return;
		if (this.spotPlate == undefined || this.spotPlate.layers == undefined) return;

		//console.log(this.spotPlate);

		var ret = HotSpotManager.cursor3D.raycaster.intersectObject(this.spotPlate, false);
//		var ret = HotSpotManager.cursor3D.raycaster.intersectObject(this.spotPlate, true);
		
		this.spotPlate.scale.set(this.scale, this.scale, this.scale);
		if (this.spotPlateOutline != undefined) {
			this.spotPlateOutline.scale.set(this.scale, this.scale, this.scale);
		}

		if (this.sphereSpot.data.record.settings.alpha != undefined && player.cms == 1) {
			//this.spotPlate.material.opacity = parseFloat(this.sphereSpot.data.record.settings.alpha) * 0.01;
			this.curOpacity = parseFloat(this.sphereSpot.data.record.settings.alpha) * 0.01;
		}
		
		this.clicked = false;

		if (ret.length > 0 && this.sphereSpot.visible) {
			if (panoramaViewStatic.root.panning) {
				//this.clicked = true;
				this.proceed();
			}
			this.hovering = true;

			Tooltip.show(this.c.title);

			this.blink(true);
		} else {
			this.hovering = false;
			this.blink(false);
//			this.spotPlate.scale.set(scale, scale, scale);
		}

		if (Equipment.dragging != null && Equipment.dragging.id == this.c.settings.accept) {
			if (this.spotPlateOutline != undefined) this.spotPlateOutline.visible = true;
			var len = Math.pow(this.x2d - player._mouseHoverX, 2) +  Math.pow(this.y2d - player._mouseHoverY, 2);
			//console.log(this.x2d + " - " + player._mouseHoverX);
			//console.log(len);
			this.spotPlate.material.opacity =  1;
			if (len < 10000) this.hovering = true;
		} else if (this.c.type == 'deliver') { //  {this.spotPlateOutline != undefined)
			if (this.delivered == undefined && (player.cms != "1" || this.sphereSpot.data.record.settings._ed_alpha != "1")) this.spotPlate.material.opacity = this.curOpacity;
			this.spotPlateOutline.visible = false;
		}
	},

	proceed: function() {
		if (this.released != undefined && this.released == false) return;

		this.released = false;
		if (this.c.require.type == "quiz") {

			Quiz.quest(this.c.require.id, "/storage/collectibles/" + this.c.icon, function(result) {
				if (result == true) this.clicked = true;
			}.bind(this));

			return;
		}

		this.clicked = true;
	},

	mouseUp: function() {
		//console.log("mouse up");
		this.released = true;

		if (this.c.type == "deliver" && this.hovering) {

			if (Equipment.dragging != null && Equipment.dragging.id == this.c.settings.accept) {
				//Equipment.dragging.shadow.css("opacity", 1);
				//Equipment.dragging.node.remove();
				this.delivered = true;
				this.spotPlate.material.opacity = 1;//this.curOpacity;
				Equipment.dragDelivered();
			}
		}

		if (this.hovering && this.c.require.type == "click_toggle") {
			this.spotPlate.material.opacity = this.spotPlate.material.opacity > 0 ? 0 : 1;//this.curOpacity;
		}
	},

	appendUI: function(node) {
		this.node.append(node);
	},

	blink: function(b) {
//		if (b) this.spotPlate.material.opacity = 0.85;
//		else this.spotPlate.material.opacity = 1;
	},

	destroy: function() {
		sphereWebGLStatic.self.preview.remove( this.spotPlate );
		this.node.remove();		
	}
}


function SpotMod(spot, type, title) {
	this.sphereSpot = spot;
	this.parent = spot.holder;	
//	this.handle = $("<div class='spot-handler' style='position:absolute; left: 0px; top: 0px;background-color:#ffffff;padding: 10px;cursor:move;border-radius:20px;display: inline-block;pointer-events: all'><i class='fas fa-arrows-alt' style='font-size:20px;'></a></div>");

	var hc = "#0ae50d";

	switch(type) {
		case "static":
			hc = "#55d7db";
		break;
		case "deliver":
			hc = "#e7a537";
		break;
	};

	this.handle = $("<div class='spot-handler' style='position:absolute; left: 0px; top: 0px;background-color:" + hc + ";padding: 7px;transform: translate(-50%, -50%);cursor:move;border-radius:20px;display: inline-block;pointer-events: all'><i class='fas fa-arrows-alt' style='font-size:20px;display:none;'></i></a><div class='label'>" + title + "</div></div>");

	this.parent.appendUI(this.handle);

	var self = this;

	this.handle.on("mouseup", function(evt) {
		SpotHelper.currentSelection = self;
		$(".spot-handler .fas").hide();
		self.handle.find(".fas").show();
		$("body").trigger("edit.spot", self.sphereSpot);
	});

	this.handle.on("mousedown", function(evt) {
		if (SpotHelper.currentSelection != self) return;
		self.dragging = true;
		self.dragX = evt.pageX;
		self.dragY = evt.pageY;

		self.origin = {"x": self.sphereSpot.screen.x, "y": self.sphereSpot.screen.y};
		self.dest = {"x": 0, "y": 0};

//		$("body").on("mousemove", this.reposition.bind(this));
		$("body").on("mousemove.spotmod", self.reposition.bind(self));

		$("body").one("mouseup", function(evt) {
			self.dragging = false;
			$("body").off("mousemove.spotmod");
			$("body").trigger("edit.spot", self.sphereSpot);
		});
	});
}

SpotMod.prototype = {

	reposition: function(evt) {
		if (this.dragging) {
			var dx = evt.pageX - this.dragX;
			var dy = evt.pageY - this.dragY;

			this.dest.x += dx;
			this.dest.y += dy;

			//var nx = this.SphereSpot.screen.x + dx;
			//var ny = this.SphereSpot.screen.y + dy;
			var nx = this.origin.x + this.dest.x;
			var ny = this.origin.y + this.dest.y;

			var sx = (nx - (HotSpotManager.playerWidth * 0.5)) / (HotSpotManager.playerWidth * 0.5);
			var sy = (ny - (HotSpotManager.playerHeight * 0.5)) / (HotSpotManager.playerHeight * 0.5);

			var v = SpotHelper.screenToSphereCoords(sx, -sy, true);

			this.sphereSpot.setPosition(v.out, v.in);

			this.dragX = evt.pageX;
			this.dragY = evt.pageY;
		}
	}
}

function SphereSpot(holder, o3d, data) {
	this.coords = {"x": o3d.out.x, "y": o3d.out.y, "z": o3d.out.z};
	this.sphere = {"x": o3d.in.x, "y": o3d.in.y, "z": o3d.in.z};
	this.updatePosition = true;
	this.visible = true;
	this.holder = holder;
	this.holder.sphereSpot = this;
	this.data = data;

	this.setPosition(this.coords, this.sphere);
}

SphereSpot.prototype = {

	edit: function() {		
		this.mod = new SpotMod(this, this.data.record.type, this.data.record.title);
	},

	setPosition: function(a, b) {
		this.coords = {"x": a.x, "y": a.y, "z": a.z};
		this.sphere = {"x": b.x, "y": b.y, "z": b.z};

		this.vec3D = new Vector3D(this.coords.x, this.coords.y, this.coords.z);
		if (this.holder.setPosition != undefined) this.holder.setPosition(this.coords, this.sphere);
	},

	remove: function() {
		this.holder.remove();
		//$("#hotspots").remove(this.node);
	},

	process: function(mtx, dir) {
		
		var result = new Vector3D(0,0,0);
		var norm = new Vector3D(0,0,0);

		result.x = this.vec3D.x;
		result.y = this.vec3D.y;
		result.z = this.vec3D.z;
		
		norm.x = this.vec3D.x;
		norm.y = this.vec3D.y;
		norm.z = this.vec3D.z;
		norm.normalize();

		if (this.holder.process != undefined) this.holder.process();

		if (norm.dot(dir) > 0) {
		
			this.visible = false;	
			this.holder.setVisibility(false);
			//this.node.css("visibility", "hidden");
			return;
		}

		this.holder.setVisibility(true);
		//this.node.css("visibility", "visible");
		
		result.transformByMatrix(mtx);
		
		var pt = result.projectTo2D();
				
		fx = -pt.x * (HotSpotManager.playerWidth * 0.5) + HotSpotManager.playerWidth * 0.5;
		fy = pt.y * (HotSpotManager.playerHeight * 0.5) + HotSpotManager.playerHeight * 0.5;
				
		if (this.updatePosition) {
			this.holder.updateScreenCoords(fx, fy);
		}

		if (fx < 0 || fy < 0 || fx > HotSpotManager.playerWidth || fy > HotSpotManager.playerHeight) {
			this.visible = false;
		} else {
			this.visible = true;
		}

		this.holder.setVisibility(this.visible);

		this.screen = {"x": fx, "y": fy};

		return {"x": fx, "y": fy};
	},

	destroy: function() {
		this.holder.destroy();
	}
	
}